//state
export var notifyState = {
  // ANCHOR N User Channels
  n_user_channels: {
    loading: false,
    data: [],
  },
  n_user_channels_status: null,
  // ANCHOR N Channel Preview Message
  n_preview_messages: {
    loading: false,
    data: [],
  },
  n_preview_messages_status: null,
  // ANCHOR N Channel Message
  n_channel_messages: {
    loading: false,
    data: [],
  },
  n_channel_messages_status: null,
  // ANCHOR N Channel Send Message
  n_channel_send_messages: {
    loading: false,
    data: [],
  },
  n_channel_send_messages_status: null,

  // ANCHOR N Channel Poll Message
  n_channel_poll_messages: {
    loading: false,
    data: [],
  },
  n_channel_poll_messages_status: null,
};

//getters
export var notifyGetters = {
  //funciones para optener informacion del state
  get_N_UserChannels: (state) => state.n_user_channels,
  get_N_PreviewMessages: (state) => state.n_preview_messages,
  get_N_ChannelMessages: (state) => state.n_channel_messages,
  get_N_ChannelSendMessages: (state) => state.n_channel_send_messages,
  get_N_ChannelPollMessages: (state) => state.n_channel_poll_messages,
};

var user_context = JSON.parse(localStorage.getItem("user_context"));

//actions
export var notifyActions = {
  async getUserChannels({ commit }) {
    commit("user_channel_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context,
        model: "mail.channel",
        sort: "",
        limit: 0,
      },
    };
    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        var datas = res.data;
        commit("user_channel_success", datas);
        return res;
      })
      .catch((err) => {
        commit("user_channel_request_error");
        return err;
      });
  },
  async get_N_PreviewMessages({ commit }, ids = []) {
    commit("preview_messages_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context,
        args: [ids],
        model: "mail.channel",
        method: "channel_fetch_preview",
        kwargs: {},
      },
    };
    await this._vm.$http
      .post("/web/dataset/call_kw/mail.channel/channel_fetch_preview", req_data)
      .then((res) => {
        var datas = res.data;
        commit("preview_messages_success", datas);
        return res;
      })
      .catch((err) => {
        commit("preview_messages_request_error");
        return err;
      });
  },
  async get_N_ChannelMessages({ commit }, ids = []) {
    commit("channel_messages_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        args: [[["channel_ids", "in", ids]]],
        model: "mail.message",
        method: "message_fetch",
        kwargs: {
          context: user_context.user_context,
        },
      },
    };
    await this._vm.$http
      .post("/web/dataset/call_kw/mail.message/message_fetch", req_data)
      .then((res) => {
        var datas = res.data;
        commit("channel_messages_success", datas);
        return res;
      })
      .catch((err) => {
        commit("channel_messages_request_error");
        return err;
      });
  },
  async get_N_ChannelSendMessages({ commit }, payload) {
    commit("channel_send_messages_request");
    const { ids, body } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        args: ids,
        model: "mail.channel",
        method: "message_post",
        kwargs: {
          body,
          message_type: "comment",
          subtype: "mail.mt_comment",
        },
      },
    };
    await this._vm.$http
      .post("/web/dataset/call_kw/mail.channel/message_post", req_data)
      .then((res) => {
        var datas = res.data;
        commit("channel_send_messages_success", datas);
        return res;
      })
      .catch((err) => {
        commit("channel_send_messages_request_error");
        return err;
      });
  },
  async get_N_ChannelPollMessages({ commit }, payload) {
    commit("channel_poll_messages_request");
    // let last = 0;
    // if (payload.last) {
    //   last = payload.last;
    // }
    const { lastId } = payload;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        channels: [],
        last: lastId,
      },
    };
    await this._vm.$http
      .post("/longpolling/poll", req_data)
      .then((res) => {
        var datas = res.data;
        commit("channel_poll_messages_success", datas);
        return res;
      })
      .catch((err) => {
        commit("channel_poll_messages_request_error");
        return err;
      });
  },
};

//mutat ions

export var notifyMutations = {
  user_channel_request(state) {
    state.n_user_channels = {
      loading: true,
      data: [],
    };
    state.n_user_channels_status = null;
  },
  user_channel_success(state, payload) {
    state.n_user_channels_status = "success";
    state.n_user_channels = {
      loading: false,
      data: payload.result ? payload.result : null,
    };
  },
  user_channel_request_error(state) {
    state.n_user_channels_status = "error";
    state.n_user_channels = {
      loading: false,
      data: [],
    };
  },

  // ANCHOR Preview Messages
  preview_messages_request(state) {
    state.n_preview_messages = {
      loading: true,
      data: [],
    };
    state.n_preview_messages_status = null;
  },
  preview_messages_success(state, payload) {
    state.n_preview_messages_status = "success";
    state.n_preview_messages = {
      loading: false,
      data: payload.result ? payload.result : null,
    };
  },
  preview_messages_request_error(state) {
    state.n_preview_messages_status = "error";
    state.n_preview_messages = {
      loading: false,
      data: [],
    };
  },
  // ANCHOR Channel Messages
  channel_messages_request(state) {
    state.n_channel_messages = {
      loading: true,
      data: [],
    };
    state.n_channel_messages_status = null;
  },
  channel_messages_success(state, payload) {
    state.n_channel_messages_status = "success";
    state.n_channel_messages = {
      loading: false,
      data: payload.result ? payload.result : null,
    };
  },
  channel_messages_request_error(state) {
    state.n_channel_messages_status = "error";
    state.n_channel_messages = {
      loading: false,
      data: [],
    };
  },

  // ANCHOR Send Message
  channel_send_messages_request(state) {
    state.n_channel_send_messages = {
      loading: true,
      data: [],
    };
    state.n_channel_messages_status = null;
  },
  channel_send_messages_success(state, payload) {
    state.n_channel_send_messages_status = "success";
    state.n_channel_send_messages = {
      loading: false,
      data: payload.result ? payload.result : null,
    };
  },
  channel_send_messages_request_error(state) {
    state.n_channel_send_messages_status = "error";
    state.n_channel_send_messages = {
      loading: false,
      data: [],
    };
  },

  // ANCHOR Send Message
  channel_poll_messages_request(state) {
    state.n_channel_poll_messages = {
      loading: true,
      data: [],
    };
    state.n_channel_poll_messages_status = null;
  },
  channel_poll_messages_success(state, payload) {
    state.n_channel_poll_messages_status = "success";
    state.n_channel_poll_messages = {
      loading: false,
      data: payload ? payload : [],
    };
  },
  channel_poll_messages_request_error(state) {
    state.n_channel_poll_messages_status = "error";
    state.n_channel_poll_messages = {
      loading: false,
      data: [],
    };
  },
};
